// Native bridge contract for the window/webview ground colour (DUE-421).
// `ios/App/App/NativeGroundPlugin.swift` implements exactly this surface on
// the Swift side. It paints the UIWindow, the WKWebView and its scrollView,
// so nothing native shows through when `Keyboard.resize: "native"` shrinks
// the webview frame.
//
// Same import-time posture as `./storekit.ts`: `registerPlugin` only builds
// a lazy proxy, and this module is pulled into every bundle path via
// `./ios.ts` <- `./index.ts` (including Telegram), so it must stay
// side-effect-free at import time.
import { registerPlugin } from "@capacitor/core";

export interface NativeGroundPluginApi {
  /** `color` is a `#RRGGBB` hex string. */
  set(options: { color: string }): Promise<void>;
}

export const NativeGround = registerPlugin<NativeGroundPluginApi>("NativeGround");
